import { AkebonoCoreModule } from '@akebono/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';

import { LotHideTranslationsButtonComponent } from './lot-hide-translations-button.component';

@NgModule({
  declarations: [LotHideTranslationsButtonComponent],
  imports: [CommonModule, AkebonoCoreModule, TranslateModule, NzButtonModule],
  exports: [LotHideTranslationsButtonComponent],
})
export class LotHideTranslationsButtonModule {}
